import React from "react";

export default function DashboardCard({ title, value, color = "blue" }) {
  const colors = {
    blue: "bg-blue-500",
    green: "bg-green-500",
    red: "bg-red-500",
  };

  return (
    <div className="p-6 rounded-xl shadow-md text-white flex flex-col items-center justify-center">
      <h3 className="text-lg font-semibold">{title}</h3>
      <p className={`text-2xl font-bold mt-2 ${colors[color]}`}>{value}</p>
    </div>
  );
}
